import styled from 'styled-components';

export const Main = styled.p`
  text-align: center;
  margin-top: 5em;
`;

export const Link = styled.span`
  font-weight: bold;
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;
`;
